import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ShellPathService } from '../services/shell-path.service';
import { UserService } from '../services/user';

export const adminGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const shellPath = inject(ShellPathService);

  return userService.getCurrentUser().pipe(
    map((user) => {
      console.log('user', user);
      if (user?.isAdmin) {
        return true;
      }
      return router.createUrlTree(shellPath.prependBase([''], state));
    }),
    catchError((error) => {
      console.error('Admin guard error:', error);
      // On error, redirect to home component
      return of(router.createUrlTree(shellPath.prependBase([''], state)));
    }),
  );
};
